function Blur(){
    return (
        <div className="Blur">
            
        </div>
    );
}

export default Blur;
